module.exports = __webpack_public_path__ + "static/media/save.a6f890f2.svg";